import React, { Fragment } from 'react'

import {
  Frame,
  SpacerVertical,
  Typography
} from '@klarna/bubble-ui'

import { BespokeInterstitialProps } from '../types'
import styles from './Checkout.css'
import LoadingSpinner from '../../../LoadingSpinner'
import { CheckoutTimeline } from './CheckoutTimeline'
import { NonAmountBasedModal } from './NonAmountBasedModal'

export interface CheckoutProps extends BespokeInterstitialProps {
  adType?: string
  theme?: string
  darkThemeToken?: string
  lightThemeToken?: string
}

export const Checkout = ({
  copy,
  theme,
}: CheckoutProps) => {
  if (!copy) return null

  const darkThemeToken = theme === 'dark'
    ? 'colors/backgrounds/subtle-inline'
    : 'colors/backgrounds/default'

  return (
    <Fragment>
      <style>{styles}</style>
      {!copy ? (
        <LoadingSpinner />
      ) : (
        <div>
          <NonAmountBasedModal
            copy={copy}
            darkThemeToken={darkThemeToken}
            theme={theme}
          />
          <SpacerVertical spaceToken="space.500" />
          <div className='titleContainer'>
            <Typography
              textToken='text-style/text/labels/tall/bold'
              textAlignToken='text-alignment/start'
            >
              {copy.timeline.title}
            </Typography>
          </div>
          <SpacerVertical spaceToken="space.300" />
          <Frame backgroundColorToken={darkThemeToken}>
            <CheckoutTimeline copy={copy.timeline.steps} />
          </Frame>
        </div>
      )}
    </Fragment>
  )
}
